<template>
  <div>
    <van-search
      v-model="currentValue"
      background="#fff"
      placeholder="请输入关键词"
      @search="handleSearch"
    >
      <van-icon
        slot="left-icon"
        class="back"
        name="back"
        color="#333"
        size="24px"
        class-prefix="iconfont"
        @click="handleBack"
      />
      <van-icon
        slot="right-icon"
        name="search"
        color="#333"
        size="20px"
        class-prefix="iconfont"
        @click="handleSearch"
      />
    </van-search>
    <div v-show="historyKeywords.length>0" class="search-history">
      <div class="search-history-title">
        搜索历史
        <van-icon
          class="search-history-clear"
          name="delete"
          color="#999"
          size="18px"
          class-prefix="iconfont"
          @click="clearHistoryKeywords"
        />
      </div>
      <ul class="search-history-list">
        <li
          v-for="keyword in historyKeywords"
          :key="keyword"
          @click="handleSearch($event,keyword)"
        >
          {{ keyword }}
        </li>
      </ul>
    </div>
    <div class="search-hot">
      <div class="search-hot-title">
        热门搜索
      </div>
      <ul class="search-hot-list">
        <li
          v-for="keyword in hotKeywords"
          :key="keyword"
          @click="handleSearch($event,keyword)"
        >
          {{ keyword }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchView',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentValue: this.value,
      hotKeywords: ['公告', '公示', '一窗受理', '便民服务', '抵押', '查封'],
      historyKeywords: []
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      this.currentValue = newValue
    }
  },
  mounted() {
    this.loadHistoryKeywordsFromCookies()
  },
  methods: {
    // 从cookies中加载历史关键字
    loadHistoryKeywordsFromCookies() {
      const serachHistory = this.$cookies.get('search-history')
      if (serachHistory && serachHistory.articleKeywords) {
        this.historyKeywords = serachHistory.articleKeywords
      }
    },
    // 保存历史关键字到cookie中
    saveHistoryKeywordsToCookies() {
      const serachHistory = this.$cookies.get('search-history') || {}
      serachHistory.articleKeywords = this.historyKeywords
      this.$cookies.set('search-history', serachHistory, -1)
    },
    // 更新历史关键字
    updateHistoryKeywords() {
      const keyword = this.currentValue
      if (keyword) {
        const index = this.historyKeywords.indexOf(keyword)
        if (index >= 0) {
          this.historyKeywords.splice(index, 1)
        }
        this.historyKeywords.unshift(keyword)
        if (this.historyKeywords.length > 20) {
          this.historyKeywords = this.historyKeywords.slice(0, 20)
        }
        this.saveHistoryKeywordsToCookies()
      }
    },
    // 清空历史关键字
    clearHistoryKeywords() {
      this.historyKeywords = []
      this.saveHistoryKeywordsToCookies()
    },
    // 设置焦点
    focus() {
      this.$el.querySelector('.van-field__control').focus()
    },
    // 处理搜索事件
    handleSearch(event, keyword) {
      if (keyword) {
        this.currentValue = keyword
      }
      this.updateHistoryKeywords()
      this.$emit('search', this.currentValue)
    },
    // 处理返回事件
    handleBack() {
      this.$emit('back')
    }
  }
}
</script>

<style scoped lang="scss">
.van-search {
  padding: 10px;
  border-bottom: 1px solid #dcdcdc;
  box-shadow: 0px 2px 5px -2px #b6b6b6;
  position: relative;
  z-index: 999;
  .van-search__content {
    background-color: #eee;
    .back {
      vertical-align: -2px;
    }
  }
}
.search-history {
  padding: 20px 10px 10px 10px;
  background-color: #eee;
  .search-history-title {
    position: relative;
    height: 24px;
    line-height: 24px;
    text-align: center;
    font-size: 14px;
    color: #999;
    .search-history-clear {
      position: fixed;
      right: 20px;
    }
  }
  .search-history-list {
    text-align: center;
    color: #a0a0a0;
    overflow: hidden;
    margin-top: 20px;
    li {
      font-size: 14px;
      float: left;
      margin: 0 10px 10px 0;
      padding: 4px 10px;
      -webkit-border-radius: 6px;
      border: 1px solid #fff;
      border-radius: 6px;
      background-color: #fff;
    }
  }
}
.search-hot {
  padding: 20px 10px 10px 10px;
  .search-hot-title {
    position: relative;
    height: 24px;
    line-height: 24px;
    text-align: center;
    font-size: 14px;
    color: #999;
  }
  .search-hot-list {
    text-align: center;
    color: #a0a0a0;
    overflow: hidden;
    margin-top: 20px;
    li {
      font-size: 14px;
      float: left;
      margin: 0 10px 10px 0;
      padding: 4px 10px;
      -webkit-border-radius: 6px;
      border: 1px solid #eee;
      border-radius: 6px;
    }
  }
}
</style>
